const convertPhoneNumberV2 = (value: string) => {
  const newValue = value.replace(/^62|^0|\D+/g, "");
  return newValue.startsWith("0")
    ? newValue.slice(1, newValue.length)
    : newValue;
};

export default convertPhoneNumberV2;
